<div class="content-grid mdl-grid css-content-container">
    <div class="mdl-layout-spacer"></div>
    <div class="mdl-cell mdl-cell--9-col mdl-cell--12-col-phone">
        <div class="content-grid mdl-grid basket-main-content css-content">

            <div class="mdl-cell mdl-cell--12-col">
                <h1 class="h1">{{'PAYMENT_TITLE' | translate}}</h1>
                <h3 class="h3">{{'PAYMENT_SUBTITLE' | translate}}</h3>
            </div>

            <div class="content-grid mdl-grid mdl-cell mdl-cell--8-col first-column mdl-cell--12-col-phone">
                <div class="mdl-cell mdl-cell--12-col">
                    <mat-card *ngIf="items">
                        <h3 class="h3" >{{'PRODUCTS_ADDED' | translate}}</h3>
                        <div class="option-card" *ngFor="let item of items">
                            <div class="option-content">
                                <div class="image">
                                    <img src="{{getUrl(item?.productMainImage)}}">
                                </div>
                                <div class="text">
                                    <div class="action" *ngIf="!buttonRemoveDisabled">
                                        <mat-icon (click)="removeFromBasket(item, $event)">close</mat-icon>
                                    </div>
                                    <strong class="title">{{item.product}}-{{item.productOption}}</strong>
                                    <div class="details">
                                        <ng-container *ngFor="let unit of item.units; let isLast=last">
                                            {{unit.pax}} {{unit.personType.name.toUpperCase() | translate}}{{isLast ? '' : ', '}}
                                        </ng-container>
                                    </div>
                                    <div class="date">
                                        {{item.bookingDateRequired ? item.date+', '+item.initTime+ (item.endTime ? ' - '+item.endTime : '')  : item.date+' - Valid for 3 months'}}
                                    </div>
                                    <div class="price">
                                        <div class="original {{item.voucherApplied?'voucher-applied':''}}">
                                            {{item.amount | currency:currencyService.currencyStr:true:'1.2-2'}}
                                        </div>
                                        <div class="with-discount" [hidden]="!item.voucherApplied">
                                            {{item.amountDiscount | currency:currencyService.currencyStr:true:'1.2-2'}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-card>
                    <mat-card *ngIf="!items || transactionError">
                        <b class="zero-elements" *ngIf="!items">{{'ZERO_ELEMENTS' | translate}}</b>
                        <b class="zero-elements" *ngIf="transactionError">Basket time expired</b>
                        <a [routerLink]="'/'" class="back" text-color="primary">
                            {{'BACK_HOME' | translate}}
                        </a>
                    </mat-card>
                </div>
            </div>
            <div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-phone-no-margin">
                <mat-card>
                    <h3 class="h3">{{'PROCESS_PAYMENT' | translate}}</h3>
                    <div class="option-card total">
                        <div class="option-content">
                            <div class="text">
                                <strong>{{'TOTAL' | translate}}:</strong>
                                <div class="price">
                                    <div class="original">
                                        {{total | currency:currencyService.currencyStr:true:'1.2-2'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="small-text">
                        <span class="more">*</span>{{'ALL_TAXES_INCLUDED' | translate}}
                    </div>
                    <div>
                        <button *ngIf="items != null && items.length > 0" color="primary" class="payment-button" mat-raised-button (click)="paymentGateway()">{{'CONTINUE_PAYMENT' | translate}}</button>
                    </div>
                    <div class="coupon-box">
                        <div class="css-form" *ngIf="items != null && items.length > 0 && !isAgent">
                            <div class="normal-text">{{'COUPON_TITLE' | translate}}</div>
                            <div class="css-form-row">
                                <input novalidate type="text" [(ngModel)]="voucher" [readonly]="voucherApplied">
                                <button *ngIf="!voucherApplied" [disabled]="!voucher || isSubmited" (click)="applyCoupon(voucher)" mat-raised-button color="neutral">{{'APPLY' | translate}}</button>
                                <button *ngIf="voucherApplied" (click)="removeCoupon()" mat-raised-button color="neutral">{{'REMOVE' | translate}}</button>
                            </div>
                            <div class="error" *ngIf="couponError">
                                <p>{{ 'COUPON_NOT_VALID' | translate }}</p>
                            </div>
                        </div>
                        <div class="spinner-coupon" [hidden]="loadingComponentUnits.isHidden">
                            <loading-component #loadUnits></loading-component>
                        </div>
                    </div>
                </mat-card>
            </div>
            <div *ngIf="false" class="content-grid mdl-grid mdl-cell mdl-cell--8-col first-column mdl-cell--12-col-phone"> 
                <div class="mdl-cell mdl-cell--12-col">
                    <mat-card class="cross-sellings" *ngIf="hasCrossSelling">
                        <h3 class="h3">{{'CROSS_SELLING' | translate}}</h3>
                        <div class="product" *ngFor="let p of crossSelling.slice(0,3)" (click)="navToProduct(p)">
                            <img src="{{getUrl(p?.main)}}" />
                            <span>{{p.name}}</span>
                            <span>{{p.minAmount | currency:currencyService.currencyStr:true:'1.2-2'}}</span>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
    <div class="mdl-layout-spacer"></div>    
</div>
